export default function(shortcode, settings) {
    let setting;
    settings.forEach(s => {
        if (s.shortcode === shortcode) {
            setting = s;
        }
    });
    if (!setting) {
        console.error("This setting does not exist: " + shortcode);
    }
    return setting.content.value;
}


// WEBPACK FOOTER //
// ./src/computationApps/getSetting.js